import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';

import { ProductService } from 'src/app/services/product.service';
import { environment } from 'src/environments/environment';
import { SimpleFieldConfig } from '../simple-field.interface';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnDestroy {

  sanitizedUrl: string = '';

  url = '';


  field: SimpleFieldConfig;
  group: UntypedFormGroup;
  text: string;
  public serverPath = environment.commonImageApi + 'gallery/';
  value: any;
  constructor(
    private snackBar: MatSnackBar,
    private productService: ProductService, private router: Router) {
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
 }

  ngOnInit(): void {
    this.text = "Save"
    this.value= this.group.value[this.field.name];
  }
  imageVisible: boolean = true;
  imageDelete: boolean;
  imagesToRemoved: any = [];
 
  
  getResult(event) {
    this.imageVisible = true;
    if (event && event.productEntityMediaGallery && event.productEntityMediaGallery.length > 0) {
      const uploadedNames = event.productEntityMediaGallery
        .map((g: any) => g.fileName)
        .filter(Boolean);
      const isSingle = (this.field as any)?.multiple === false;
      if (isSingle) {
        this.group.value[this.field.name] = uploadedNames[0];
      } else {
        const existing = this.group.value[this.field.name];
        const existingArray = existing ? String(existing).split(',').map(s => s.trim()).filter(Boolean) : [];
        const combined = Array.from(new Set([...existingArray, ...uploadedNames]));
        this.group.value[this.field.name] = combined.join(',');
      }
      this.group.patchValue(this.group.value);
      this.value = this.group.value[this.field.name];
    }
  }

  getValueList(): string[] {
    if (!this.value) return [];
    if (Array.isArray(this.value)) return this.value;
    return String(this.value).split(',').map(s => s.trim()).filter(Boolean);
  }

  getDisplayFileName(item: string): string {
    if (!item) return '';
    return item.split('/').pop() || item;
  }

  removeSingleFile(index: number): void {
    const list = this.getValueList();
    if (index >= 0 && index < list.length) {
      list.splice(index, 1);
      this.value = list.join(',');
      this.group.value[this.field.name] = this.value;
      this.group.patchValue(this.group.value);
    }
  }

  isImageFile(item: string): boolean {
    if (!item) return false;
    const ext = item.split('.').pop()?.toLowerCase() || '';
    return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp'].includes(ext);
  }

  getFileIcon(item: string): string {
    if (!item) return 'insert_drive_file';
    const ext = item.split('.').pop()?.toLowerCase() || '';
    if (['pdf'].includes(ext)) return 'picture_as_pdf';
    if (['doc', 'docx'].includes(ext)) return 'description';
    if (['xls', 'xlsx', 'csv'].includes(ext)) return 'table_chart';
    if (['ppt', 'pptx'].includes(ext)) return 'slideshow';
    if (['mp4', 'avi', 'mov', 'mkv', 'webm'].includes(ext)) return 'movie';
    if (['mp3', 'wav', 'ogg', 'm4a'].includes(ext)) return 'audiotrack';
    if (['zip', 'rar', '7z', 'tar', 'gz'].includes(ext)) return 'folder_zip';
    return 'insert_drive_file';
  }

  cancelUpload() {
    this.imageVisible = true;
  }

  logo() {
    this.imageVisible = false;
  }



  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
